export const convertDataLinkEvent = (data) => {
  return {
    error_code: data.error_code || '',
    error_message: data.error_message || '',
    error_type: data.error_type || '',
    exit_status: data.exit_status || '',
    institution_id: data.institution_id || '',
    institution_name: data.institution_name || '',
    institution_search_query: data.error_code || '',
    link_session_id: data.error_code || '',
    mfa_type: data.mfa_type || '',
    request_id: data.request_id || '',
    selection: data.selection || '',
    timestamp: data.timestamp || '',
    view_name: data.view_name || '',
  };
};

export const convertMetaDataSuccess = (metadata) => {
  return {
    metadata: {
      accounts: metadata.accounts,
      institution: metadata.institution,
      link_session_id: metadata.link_session_id,
    },
    publicAccessToken: metadata.public_token,
  };
};

export const convertMetaDataExit = (transactionInfo) => {
  return {
    metadata: {
      obvStatus: transactionInfo.status,
      institution: {
        name: transactionInfo.institutionName,
      },
    },
    error: null,
  };
};
